export default __webpack_public_path__ + "static/media/pic3.f5973012.jpg";